import { jsxs as i, jsx as o } from "react/jsx-runtime";
import e from "./styles.module.less.js";
const u = (c) => {
  const {
    label: l,
    path: t,
    isScrolledHeader: a,
    className: s,
    onClick: d,
    labelClassName: n,
    children: r,
    isOpen: $
  } = c;
  return t ? /* @__PURE__ */ i(
    "a",
    {
      href: t,
      className: `${e.gradientButton} ${a ? e.isScrolled : ""} ${s ?? ""}`,
      children: [
        /* @__PURE__ */ o("div", { className: `${e.gradientButtonLabel} ${n ?? ""}`, children: l }),
        r
      ]
    }
  ) : /* @__PURE__ */ i(
    "button",
    {
      className: `${e.gradientButton} ${a ? e.isScrolled : ""} ${$ ? e.isOpen : ""}
      } ${s ?? ""}`,
      onClick: d,
      children: [
        /* @__PURE__ */ o("div", { className: `${e.gradientButtonLabel} ${n ?? ""}`, children: l }),
        r
      ]
    }
  );
};
export {
  u as GradientButton
};
